import Lista from './Lista';

export const TreinamentoLista = Lista;
